import { render } from "./CreateLink.vue?vue&type=template&id=3bb290cf&scoped=true"
import script from "./CreateLink.vue?vue&type=script&lang=js"
export * from "./CreateLink.vue?vue&type=script&lang=js"

import "./CreateLink.vue?vue&type=style&index=0&id=3bb290cf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb290cf"]])

export default __exports__